module.exports = "/_next/static/images/a4eba02e5e98f7e58802d47861affc0a-nobureaucracy@0.5x.png";